// As strings das telas do grupo Solicitação (#5249): Solicitado por, Política, Aprovações e
// Opções apresentadas. Os rótulos das LINHAS seguem em `trips.flightVoucher.*`.
const PT_BR = {
  'trips.voucherRequest.requester': 'Solicitante',
  'trips.voucherRequest.requestData': 'Dados da solicitação',
  'trips.voucherRequest.motive': 'Motivo',
  'trips.voucherRequest.justification': 'Justificativa',
  'trips.voucherRequest.obs': 'Observação',
  'trips.voucherRequest.costCenter': 'Centro de custo',
  'trips.voucherRequest.policyGroup': 'Políticas do grupo {{name}}',
  'trips.voucherRequest.rules': 'Regras',
  'trips.voucherRequest.rule.ok': 'Dentro da política',
  'trips.voucherRequest.rule.broken': 'Violada',
  'trips.voucherRequest.rule.skipped': 'Não aplicada',
  'trips.voucherRequest.approved': 'Aprovado',
  'trips.voucherRequest.pending': 'Pendente',
  'trips.voucherRequest.options': 'Opções apresentadas',
  'trips.voucherRequest.optionsCount_one': '{{count}} opção',
  'trips.voucherRequest.optionsCount_other': '{{count}} opções',
  'trips.voucherRequest.outbound': 'Ida',
  'trips.voucherRequest.return': 'Volta',
  'trips.voucherRequest.roundTrip': 'Ida e volta',
  'trips.voucherRequest.chosen': 'Selecionado',
  'trips.voucherRequest.cheapest': 'Mais barato',
  'trips.voucherRequest.expensive': 'Mais caro',
  'trips.voucherRequest.hotelOptions': 'Opções',
  'trips.voucherRequest.optionsNote':
    'Os valores exibidos nos resultados podem variar e não garantem disponibilidade na emissão.',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.voucherRequest.requester': 'Requester',
  'trips.voucherRequest.requestData': 'Request details',
  'trips.voucherRequest.motive': 'Reason',
  'trips.voucherRequest.justification': 'Justification',
  'trips.voucherRequest.obs': 'Note',
  'trips.voucherRequest.costCenter': 'Cost center',
  'trips.voucherRequest.policyGroup': '{{name}} group policies',
  'trips.voucherRequest.rules': 'Rules',
  'trips.voucherRequest.rule.ok': 'Within policy',
  'trips.voucherRequest.rule.broken': 'Broken',
  'trips.voucherRequest.rule.skipped': 'Not applied',
  'trips.voucherRequest.approved': 'Approved',
  'trips.voucherRequest.pending': 'Pending',
  'trips.voucherRequest.options': 'Options presented',
  'trips.voucherRequest.optionsCount_one': '{{count}} option',
  'trips.voucherRequest.optionsCount_other': '{{count}} options',
  'trips.voucherRequest.outbound': 'Outbound',
  'trips.voucherRequest.return': 'Return',
  'trips.voucherRequest.roundTrip': 'Round trip',
  'trips.voucherRequest.chosen': 'Selected',
  'trips.voucherRequest.cheapest': 'Cheapest',
  'trips.voucherRequest.expensive': 'Most expensive',
  'trips.voucherRequest.hotelOptions': 'Options',
  'trips.voucherRequest.optionsNote':
    'The prices shown may change and do not guarantee availability at issuance.',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.voucherRequest.requester': 'Solicitante',
  'trips.voucherRequest.requestData': 'Datos de la solicitud',
  'trips.voucherRequest.motive': 'Motivo',
  'trips.voucherRequest.justification': 'Justificación',
  'trips.voucherRequest.obs': 'Observación',
  'trips.voucherRequest.costCenter': 'Centro de costo',
  'trips.voucherRequest.policyGroup': 'Políticas del grupo {{name}}',
  'trips.voucherRequest.rules': 'Reglas',
  'trips.voucherRequest.rule.ok': 'Dentro de la política',
  'trips.voucherRequest.rule.broken': 'Incumplida',
  'trips.voucherRequest.rule.skipped': 'No aplicada',
  'trips.voucherRequest.approved': 'Aprobado',
  'trips.voucherRequest.pending': 'Pendiente',
  'trips.voucherRequest.options': 'Opciones presentadas',
  'trips.voucherRequest.optionsCount_one': '{{count}} opción',
  'trips.voucherRequest.optionsCount_other': '{{count}} opciones',
  'trips.voucherRequest.outbound': 'Ida',
  'trips.voucherRequest.return': 'Vuelta',
  'trips.voucherRequest.roundTrip': 'Ida y vuelta',
  'trips.voucherRequest.chosen': 'Seleccionado',
  'trips.voucherRequest.cheapest': 'Más barato',
  'trips.voucherRequest.expensive': 'Más caro',
  'trips.voucherRequest.hotelOptions': 'Opciones',
  'trips.voucherRequest.optionsNote':
    'Los valores mostrados pueden variar y no garantizan disponibilidad en la emisión.',
};

export const REQUEST_SCREENS_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
